import { useEffect, useState } from "react";
import className from "classnames";
import { useNavigate, useParams } from "react-router-dom"
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetCallAccountQuery } from "features/call_account/callAccountApiSlice";
import EditCallAccount from "../EditCallAccount/EditCallAccount";

const ViewCallAccount = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Call Account"));
  }, [dispatch]);

  const { data: callAccount } = useGetCallAccountQuery(params?.id);

//   let accountBtnEl = null;

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible); // Toggle visibility on button click
  };

  const extensionData = [
    { label: "Name", value: callAccount?.name },
    { label: "Number", value: callAccount?.number },
    { label: "Balance", value: callAccount?.balance },
    { label: "Credit Limits", value: callAccount?.credit_limits },
    { label: "Postpaid", value: callAccount?.postpaid },
    { label: "Type", value: callAccount?.type },
    { label: "Pricelist", value: callAccount?.pricelist?.name },
    { label: "Local Charge Per Min", value: callAccount?.local_charge_per_min },
    { label: "Enabled", value: callAccount?.enabled ? 'Yes' : 'No' },
    // { label: "Created By", value: callAccount?.created_by },
  ];

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />

          <div>
            {/* Button to toggle visibility */}
            <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
              {isEditVisible ? (
                <RiCloseFill color={Globals.colorRed} size={30} />
              ) : (
                <>
                  <h3>Edit Call Account </h3>
                  <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                </>
              )}
            </Button>
          </div>
        </div>
        {/* <div>
          <button
            onClick={onViewDevicesBtnHandler}
            className={utilityStyles.btn}
          >
            <h3>View extension devices</h3>
            <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
          </button>
        </div> */}
      </div>

      {/* Edit Account Component Start*/}
      {isEditVisible && (
        <EditCallAccount label={label} />)
      }

    </>
  )
}

export default ViewCallAccount